import script from "./search_bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./search_bar.vue?vue&type=script&setup=true&lang=ts"

import "./search_bar.vue?vue&type=style&index=0&id=3e821af4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e821af4"]])

export default __exports__